import CloneTemplateController from './CloneTemplateController';

export default CloneTemplateController;
